<template>
  <v-app>
    <Navbar v-if="authenticated" />
    <v-content class="grey lighten-3">
      <Notification/>
      <!-- <transition mode="out-in"> -->
        <router-view></router-view>
      <!-- </transition> -->
    </v-content>
    <Footer v-if="authenticated" />
  </v-app>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import Notification from "@/components/notification/Notification";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";

export default {
  name: "App",
  components: {
    Notification,
    Navbar,
    Footer
  },
  created() {
    this.$http.interceptors.response.use(undefined, err => {
      return new Promise((resolve, reject) => {
        if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
          this.$store.dispatch('logout');
        }
      });
    });
  },
  computed: {
    ...mapGetters(['authenticated'])
  }
};
</script>

<style>
.text-link {
  text-decoration: none;
}
.text-link:hover {
  text-decoration: underline;
}
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
/* Track */
::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.15);
}
/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}
/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.v-enter,
.v-leave-to {
  opacity: 0;
}
.v-enter {
  transform: translate3d(0, -20px, 0);
}
.v-leave-to {
  transform: translate3d(0, 20px, 0);
}
.v-enter-active,
.v-leave-active {
  transition: all .3s;
}
.markdown-container p {
  margin: 0;
}
.markdown-container code {
  padding: 0 10px;
}
.markdown-container table {
  border-collapse: collapse;
  width: 100%;
}
.markdown-container td, th {
  border: 1px solid #ccc;
  text-align: left;
  padding: 8px;
}
.markdown-container tr:nth-child(even) {
  background-color: #dddddd;
}
.markdown-container img {
  max-width: 100%;
}
</style>

